export function isBetween(number: number, min: number, max: number): boolean {
  return (number - min) * (number - max) <= 0;
}
